import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AppGuard, NoAccessFallback, usePermission } from '@/components/guards/permission-guard';

/** A source manager or an accountant can enter the shared workspace. */
export function TravelCariAccountGuard({ children }: { children: ReactNode }) {
  const { t } = useTranslation('travelCari');
  const customers = usePermission('CUSTOMERS', 'VIEW', 'TRAVEL');
  const partners = usePermission('PARTNERS', 'VIEW', 'TRAVEL');
  const accounting = usePermission('ACCOUNTING', 'VIEW', 'TRAVEL');
  return (
    <AppGuard app="TRAVEL" fallback={<NoAccessFallback message={t('account.errors.permission')} />}>
      {customers || partners || accounting ? (
        children
      ) : (
        <NoAccessFallback message={t('account.errors.permission')} />
      )}
    </AppGuard>
  );
}
